import { Component } from '@grafikr/components';

import { assertNonNullish, NonNullish } from 'utils/nullish-check';

export default Component((node) => {
  const { start, component } = node.dataset;

  assertNonNullish(start);
  assertNonNullish(node.parentElement);

  const update = () => {
    const siblings = Array.from(NonNullish(node.parentElement).children).filter(
      (child) => (child as HTMLElement).dataset.component !== component,
    );

    if (siblings.length >= parseInt(start, 10)) {
      node.hidden = false;
    } else {
      node.hidden = true;
    }
  };

  const observer = new MutationObserver((entries) => {
    entries.forEach(() => {
      update();
    });
  });

  observer.observe(node.parentElement, {
    childList: true,
    subtree: true,
  });
});
